// import React, { useCallback, useContext, useMemo } from 'react'
import React, { useMemo } from 'react'
import { generateLoyaltyPointsCalculatorCruiseOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'
import LoyaltyPointsEarn from 'loyalty/components/Earn/LoyaltyPointsEarn'

interface Props {
  offer: App.CruiseOffer
  bookingPrice?: number
  calculationType: 'estimate' | 'exact'
}

/** NOTE - info modal has been disabled for MVP as not displayed for any other verticals */
function CruiseLoyaltyPoints({ offer, bookingPrice, calculationType }: Props) {
  const pointsEarnCalculationOptions = useMemo(
    () => [generateLoyaltyPointsCalculatorCruiseOptions(offer, { bookingPrice, nights: offer?.duration })],
    [offer, bookingPrice],
  )

  return <LoyaltyPointsEarn
    calculationRequests={pointsEarnCalculationOptions}
    calculationType={calculationType}
  />
}

export default CruiseLoyaltyPoints
